module.exports = __webpack_public_path__ + "img/cbt.939e2960.png";